import './CreativeSection.scss';

import { Col, Row } from 'react-bootstrap';

import AppInput from '../../../../commons/inputs/AppInput';
import AppTextAreaInput from '../../../../commons/inputs/AppTextAreaInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InformativeModal from './InformativeModal';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

function CreativeSection({ values, errors, touched, handleChange, imageFile, setImageFile, setFieldValue, isEdit }) {
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [currentField, setCurrentField] = useState(null);
    const [linkType, setLinkType] = useState('link'); // 'whatsapp' ou 'link'
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [whatsappMessage, setWhatsappMessage] = useState('Olá, gostaria de agendar um horário!');

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setImageFile(file);
        }
    };

    const removeImage = () => {
        setImageFile(null);
    };

    const openInfoModal = (field) => {
        setCurrentField(field);
        setShowInfoModal(true);
    };

    const closeInfoModal = () => {
        setShowInfoModal(false);
        setCurrentField(null);
    };

    const handleLinkTypeChange = (type) => {
        setLinkType(type);
        if (type === 'whatsapp') {
            // Limpar o campo de URL quando mudar para WhatsApp
            setFieldValue('destinationUrl', '');
        }
    };
    const handleWhatsappNumberChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); // Remove tudo que não é número

        // Limita a 11 dígitos (DDD + 9 dígitos)
        if (value.length > 11) {
            value = value.slice(0, 11);
        }

        setWhatsappNumber(value);

        // Gera o link do WhatsApp automaticamente (adiciona +55 apenas no link)
        if (value.length >= 10) {
            const whatsappLink = `https://wa.me/55${value}?text=${encodeURIComponent(whatsappMessage)}`;
            setFieldValue('destinationUrl', whatsappLink);
        } else {
            setFieldValue('destinationUrl', '');
        }
    };

    const handleWhatsappMessageChange = (e) => {
        const message = e.target.value;
        setWhatsappMessage(message);

        // Atualiza o link com a nova mensagem (adiciona +55 apenas no link)
        if (whatsappNumber.length >= 10) {
            const whatsappLink = `https://wa.me/55${whatsappNumber}?text=${encodeURIComponent(message)}`;
            setFieldValue('destinationUrl', whatsappLink);
        }
    };

    const formatWhatsappNumber = (value) => {
        // Formata o número para exibição: (11) 99999-9999
        if (!value) return '';

        const cleaned = value.replace(/\D/g, '');

        if (cleaned.length <= 2) {
            return `(${cleaned}`;
        } else if (cleaned.length <= 6) {
            return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
        } else if (cleaned.length <= 11) {
            return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
        }

        return value;
    };

    const previewUrl = imageFile
        ? URL.createObjectURL(imageFile)
        : values.imageUrl || null;

    const buildInfoByField = () => {
        if (!currentField) return null;

        switch (currentField) {
            case 'primaryText':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">📝 O que é o Texto Principal?</h6>
                        <p>
                            O <strong>texto principal</strong> é a <strong>mensagem que aparece acima da imagem</strong> do seu anúncio.
                        </p>

                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>📱 <strong>Primeira coisa que o cliente lê</strong> ao ver seu anúncio</li>
                            <li>✍️ <strong>Limite:</strong> Até 500 caracteres (recomendado: 125 caracteres)</li>
                            <li>🎯 <strong>Objetivo:</strong> Chamar atenção e despertar interesse</li>
                            <li>💡 <strong>Tom:</strong> Seja direto, claro e persuasivo</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Exemplos práticos para salões:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>✨ Promoção:</strong>
                            <p className="mb-0 small">"Corte + Escova por apenas R$ 59,90! Agende agora e garanta seu horário. Válido até domingo! 💇‍♀️"</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>🎁 Novidade:</strong>
                            <p className="mb-0 small">"Chegou! Novo tratamento de hidratação profunda. Cabelos brilhantes e saudáveis em 30 minutos. Experimente! ✨"</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>⭐ Institucional:</strong>
                            <p className="mb-0 small">"Há 10 anos cuidando da sua beleza! Profissionais qualificados e produtos de primeira linha. Venha nos conhecer! 💜"</p>
                        </div>

                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Use emojis, faça perguntas e inclua um chamado para ação (CTA) como "Agende agora", "Saiba mais", "Aproveite"!
                        </div>
                    </div>
                );

            case 'headline':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">🎯 O que é o Título (Headline)?</h6>
                        <p>
                            O <strong>título</strong> aparece <strong>abaixo da imagem</strong>, em destaque, e complementa o texto principal.
                        </p>

                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>📌 <strong>Posição:</strong> Logo abaixo da imagem, em negrito</li>
                            <li>✍️ <strong>Limite:</strong> Até 100 caracteres (recomendado: 40 caracteres)</li>
                            <li>🎯 <strong>Objetivo:</strong> Reforçar a mensagem principal</li>
                            <li>💡 <strong>Tom:</strong> Seja objetivo e impactante</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Exemplos práticos para salões:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>✨ Promoção:</strong>
                            <p className="mb-0 small">"50% OFF em todos os serviços"</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>🎁 Novidade:</strong>
                            <p className="mb-0 small">"Novo: Alisamento sem formol"</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>⭐ Agendamento:</strong>
                            <p className="mb-0 small">"Agende online em 2 minutos"</p>
                        </div>

                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> O título deve ser curto e direto. Pense nele como uma "manchete de jornal"!
                        </div>
                    </div>
                );

            case 'destinationUrl':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">🔗 Para onde direcionar o cliente?</h6>
                        <p>
                            Escolha para onde o cliente será direcionado ao <strong>clicar no anúncio</strong>.
                        </p>

                        <h6 className="fw-bold mt-3">Opções disponíveis:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>💬 WhatsApp (Recomendado):</strong>
                            <p className="mb-0 small">Cliente vai direto para uma conversa no WhatsApp com você. Melhor taxa de conversão para salões!</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>🌐 Link Personalizado:</strong>
                            <p className="mb-0 small">Direciona para seu site, Instagram, sistema de agendamento online, etc.</p>
                        </div>

                        <h6 className="fw-bold mt-3">Exemplos de links personalizados:</h6>
                        <ul>
                            <li>🌐 Site: https://seusalao.com.br/agendar</li>
                            <li>📱 Instagram: https://instagram.com/seusalao</li>
                            <li>📅 Agendamento: https://agendamento.seusalao.com.br</li>
                        </ul>

                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> WhatsApp tem melhor conversão porque o cliente já inicia uma conversa direta com você!
                        </div>
                    </div>
                );

            case 'image':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">🖼️ O que é a Imagem do Anúncio?</h6>
                        <p>
                            A <strong>imagem</strong> é o <strong>elemento visual principal</strong> do seu anúncio. É o que mais chama atenção!
                        </p>

                        <h6 className="fw-bold mt-3">Especificações técnicas:</h6>
                        <ul>
                            <li>📐 <strong>Tamanho recomendado:</strong> 1200x628 pixels (proporção 1.91:1)</li>
                            <li>📁 <strong>Formatos aceitos:</strong> JPG, PNG</li>
                            <li>💾 <strong>Tamanho máximo:</strong> 30 MB</li>
                            <li>📝 <strong>Texto na imagem:</strong> Máximo 20% da área (regra do Facebook)</li>
                        </ul>

                        <h6 className="fw-bold mt-3">Dicas para uma boa imagem:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>✅ Faça:</strong>
                            <p className="mb-0 small">• Use fotos de alta qualidade<br />• Mostre o resultado do serviço<br />• Use cores vibrantes<br />• Inclua pessoas felizes</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>❌ Evite:</strong>
                            <p className="mb-0 small">• Imagens borradas ou pixeladas<br />• Muito texto na imagem<br />• Fotos genéricas de banco de imagens<br />• Imagens escuras</p>
                        </div>

                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Use fotos reais do seu salão e dos seus trabalhos. Clientes adoram ver resultados antes e depois!
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="create-ad-section">
            <h4 className="create-ad-section-title">🎨 Criativo do Anúncio</h4>

            <p className="section-description" style={{
                fontSize: '15px',
                color: '#5a6c7d',
                marginBottom: '24px',
                lineHeight: '1.6',
                padding: '12px 16px',
                background: '#f8f9fa',
                borderRadius: '8px',
                borderLeft: '4px solid #667eea'
            }}>
                O <strong>criativo</strong> é tudo que o cliente vê no seu anúncio: <strong>texto, título, imagem e link</strong>.
                É a parte mais importante, pois é o que vai <strong>chamar atenção e convencer as pessoas a clicarem</strong>.
                Capriche nas palavras e escolha uma imagem atraente! 🚀
            </p>

            <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <label className="field-label" style={{ margin: 0 }}>
                        Texto Principal <span className="required">*</span>
                    </label>
                    <button
                        type="button"
                        className="info-button"
                        onClick={() => openInfoModal('primaryText')}
                        title="Clique para entender o texto principal"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                </div>
                <AppTextAreaInput
                    disabled={isEdit}
                    isRequired
                    name="primaryText"
                    label=""
                    value={values.primaryText}
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    placeholder="Ex: Transforme seu visual! Corte + Escova por apenas R$ 59,90. Agende agora! 💇‍♀️"
                />
                <small className="field-hint">
                    💡 Máximo 500 caracteres. Seja direto e persuasivo!
                </small>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <label className="field-label" style={{ margin: 0 }}>
                        Título (Headline) <span className="required">*</span>
                    </label>
                    <button
                        type="button"
                        className="info-button"
                        onClick={() => openInfoModal('headline')}
                        title="Clique para entender o título"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                </div>
                <AppInput
                    disabled={isEdit}
                    isRequired
                    name="headline"
                    label=""
                    type="text"
                    value={values.headline}
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    placeholder="Ex: Agende online em 2 minutos"
                />
                <small className="field-hint">
                    💡 Máximo 100 caracteres. Seja objetivo e impactante!
                </small>
            </div>

            {/* Seletor de Tipo de Link */}
            <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <label className="field-label" style={{ margin: 0 }}>
                        Para onde direcionar o cliente? <span className="required">*</span>
                    </label>
                    <button
                        type="button"
                        className="info-button"
                        onClick={() => openInfoModal('destinationUrl')}
                        title="Clique para entender as opções"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                </div>

                {/* Botões de seleção */}
                {
                    !isEdit && <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                        <button
                            type="button"
                            onClick={() => handleLinkTypeChange('whatsapp')}
                            style={{
                                flex: 1,
                                padding: '16px',
                                border: linkType === 'whatsapp' ? '3px solid #25D366' : '2px solid #e9ecef',
                                borderRadius: '10px',
                                background: linkType === 'whatsapp' ? '#e8f8f0' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ fontSize: '32px' }}>💬</span>
                            <strong style={{ fontSize: '16px', color: '#2c3e50' }}>WhatsApp</strong>
                            <small style={{ color: '#5a6c7d', fontSize: '13px' }}>Recomendado</small>
                        </button>

                        <button
                            type="button"
                            onClick={() => handleLinkTypeChange('link')}
                            style={{
                                flex: 1,
                                padding: '16px',
                                border: linkType === 'link' ? '3px solid #667eea' : '2px solid #e9ecef',
                                borderRadius: '10px',
                                background: linkType === 'link' ? '#f0f2ff' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ fontSize: '32px' }}>🔗</span>
                            <strong style={{ fontSize: '16px', color: '#2c3e50' }}>Link Personalizado</strong>
                            <small style={{ color: '#5a6c7d', fontSize: '13px' }}>Site, Instagram, etc.</small>
                        </button>
                    </div>
                }

                {/* Campos condicionais */}
                {linkType === 'whatsapp' ? (
                    <Row>
                        <Col xs={12} md={6}>
                            <label className="field-label">
                                Número do WhatsApp <span className="required">*</span>
                            </label>
                            <input
                                type="tel"
                                value={formatWhatsappNumber(whatsappNumber)}
                                onChange={handleWhatsappNumberChange}
                                placeholder="(11) 99999-9999"
                                style={{
                                    width: '100%',
                                    height: '60px',
                                    padding: '0 16px',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                            <small className="field-hint">
                                💡 Digite o DDD + número (ex: 11999999999)
                            </small>
                        </Col>
                        <Col xs={12} md={6}>
                            <label className="field-label">
                                Mensagem inicial (opcional)
                            </label>
                            <input
                                type="text"
                                value={whatsappMessage}
                                onChange={handleWhatsappMessageChange}
                                placeholder="Olá, gostaria de agendar um horário!"
                                style={{
                                    width: '100%',
                                    height: '60px',
                                    padding: '0 16px',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                            <small className="field-hint">
                                💡 Mensagem que aparecerá no WhatsApp
                            </small>
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <AppInput
                            disabled={isEdit}
                            isRequired
                            name="destinationUrl"
                            label=""
                            type="url"
                            value={values.destinationUrl}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            placeholder="https://seusalao.com.br ou https://instagram.com/seusalao"
                        />
                        <small className="field-hint">
                            💡 Cole o link completo (deve começar com https://)
                        </small>
                    </div>
                )}

                {/* Preview do link gerado */}
                {values.destinationUrl && (
                    <div style={{
                        marginTop: '12px',
                        padding: '12px',
                        background: '#e8f8f0',
                        borderRadius: '8px',
                        border: '1px solid #25D366'
                    }}>
                        <small style={{ color: '#155724', fontWeight: 600 }}>
                            ✅ Link gerado:
                        </small>
                        <br />
                        <small style={{
                            color: '#155724',
                            wordBreak: 'break-all',
                            fontSize: '12px'
                        }}>
                            {values.destinationUrl}
                        </small>
                    </div>
                )}
            </div>

            <div style={{ marginTop: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <label className="field-label" style={{ margin: 0 }}>
                        Imagem do Anúncio <span className="required">*</span>
                    </label>
                    <button
                        type="button"
                        className="info-button"
                        onClick={() => openInfoModal('image')}
                        title="Clique para entender a imagem"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </button>
                </div>
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{
                        width: '100%',
                        padding: '10px',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        fontSize: '15px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                    }}
                />
                <small className="field-hint">
                    💡 Formatos: JPG, PNG | Tamanho recomendado: 1200x628px | Máximo 20% de texto na imagem
                </small>

                {previewUrl && (
                    <div className="ad-image-preview" style={{
                        marginTop: '16px',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        position: 'relative'
                    }}>
                        <img
                            src={previewUrl}
                            alt="Preview"
                            style={{
                                width: '100%',
                                height: 'auto',
                                display: 'block'
                            }}
                        />

                        {imageFile && (
                            <button
                                type="button"
                                className="remove-image-btn"
                                onClick={removeImage}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    background: 'rgba(220, 53, 69, 0.9)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                ✕ Remover imagem
                            </button>
                        )}
                    </div>
                )}
            </div>

            {/* Modal Informativo */}
            {showInfoModal && (
                <InformativeModal
                    show={showInfoModal}
                    closeModal={closeInfoModal}
                >
                    {buildInfoByField()}
                </InformativeModal>
            )}
        </div>
    );
}

export default CreativeSection;